import React from 'react';
import './About.css';

const About = () => {
  return (
    <div className="about-section" id="about">

      <h2 className="section-title">About</h2>
      <p className="section-subtitle">
        I'm a passionate Full Stack Developer with experience in building web applications using technologies like React, Spring Boot, and MySQL.
      I love solving real-world problems, learning new tools, and contributing to meaningful projects.
      </p>

      <div className="about-info">
        <h3>Full-Stack Developer</h3>
        <h4><em>Information</em></h4>
        <ul className="info-list">
          <li><strong>Phone:</strong> +91 9370730634</li>
          <li><strong>City:</strong> Pimpri-Chinchwad, Pune</li>
          <li><strong>Age:</strong> 24</li>
          <li><strong>Degree:</strong> BSc In Information Technology</li>
          <li><strong>Email:</strong> <a href="mailto:virajmhatre74@gmail.com">virajmhatre74@gmail.com</a></li>
          <li><strong>Freelance:</strong> Available</li>
        </ul>
        {/* <p className="about-bio">
          I'm a passionate full-stack developer with a strong foundation in information technology. I specialize
          in building dynamic and scalable web applications. With expertise in both front-end and back-end
          technologies, I strive to deliver high-quality solutions that meet user needs.
        </p> */}
      </div>
    </div>
  );
};

export default About;
